/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-inline-styles */
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  Dimensions,
} from 'react-native';
import { launchCamera, launchImageLibrary } from 'react-native-image-picker';
import * as FileSystem from 'expo-file-system';
import { readAsync } from '@lodev09/react-native-exify';
import { manipulateAsync, SaveFormat } from 'expo-image-manipulator';
import { format, parseISO } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import Toast from 'react-native-toast-message';

import CheckBox from '@components/form/CheckBox';
import SociollaText from '@components/sociolla/SociollaText';
import { NoTranslate } from '@components/shared/TranslationContext';
import SociollaTable from '@components/sociolla/SociollaTable';
import SociollaTabs from '@components/sociolla/SociollaTabs';
import SociollaCard from '@components/sociolla/SociollaCard';
import Image from '@components/global/Image';
import ScrollContainer from '@components/global/ScrollContainer';
import Button from '@components/form/Button';
import ItemDetail from '@components/global/ItemDetail';
import ModalLoyalty from '@components/customer/loyalty/ModalLoyalty';
import MoreButton from '@components/navbar/MoreButton';
import FloatCommentButton from '@components/comment/FloatCommentButton';
import CommentHeaderButton from '@components/comment/CommentHeaderButton';
import CommentDrawer from '@components/comment/CommentDrawer';
import Address from '@components/customer/register/Address';
import ModalAddress from '@components/customer/register/ModalAddress';
import ESignature from '@/screens/inventory/components/ESignature';
import MapPicker from '@components/form/MapPicker';
import ModalImage from '@components/modal/ModalImage';
import ModalLog from '@components/modal/ModalLog';
import ModalReject from '@components/customer/ModalReject';
import InputGroup from '@components/form/InputGroup';
import VipBadge from '@components/customer/VipBadge';
import ModalHalf from '@components/modal/ModalHalf';
import { CUSTOMER_LOG_FORMATTER } from '@/constants/log';

import Colors from '@global/colors';
import { isWeb, isNative, fullWidth, isAndroid, isIos } from '@global/screens';
import { backSection, backSectionText } from '@/assets/styles/mainStyles';
import {
  buttonRounded,
  buttonRow,
  buttonFloating,
} from '@/assets/styles/buttonStyles';
import * as Layout from '@components/screen/Layout';
import {
  isVn,
  uploadS3,
  hasNoAccess,
  getErrorMessage,
  generateStatus,
  currency,
  isKeyExists,
  downloadFile,
  generateMimeType,
  exportPdf,
  isAllowedAttachmentFormat,
  getHeaderTitleStyle,
  savePhotoToGallery,
} from '@global/helpers';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import {
  getCustomerId,
  updateCustomerStatusById,
  updateCustomerStateById,
  updateCustomerDocumentsById,
  deleteCustomerDocumentsById,
  getCustomerAveragePurchase,
  getClusterByCustomerId,
  getCustomerTotalInvoice,
  MsAccount,
  updateCustomerSignaturesById,
  patchCustomerSalesTeamPersons,
  updateCustomerAddressPremium,
} from '@api/ms-account';
import { MsB2b } from '@api/ms-b2b';
import useApi from '@/hooks/useApi';
import { getLoyaltyCustomers, getSalesOrderCount } from '@api/ms-order';
import { getDocumentAsync } from 'expo-document-picker';
import { showImage } from '@/store/global';
import {
  PAYMENT_TYPES_OBJ,
  CUSTOMER_TYPES_OBJ,
  // VISIT_DAYS_OBJ,
  // VISIT_WEEKS_OBJ,
  PKP_TYPES_OBJ,
  AUTOMATE_CREDIT_LIMIT,
  WHT,
  ATTACHMENT_FORMAT_ERROR_TITLE,
  ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
} from '@/constants';
import {
  setDeliveryAddress,
  setStoreAddress,
  setInvoiceAddress,
  setKtpAddress,
  setNpwpAddress,
} from '../../store/customer';

const img = require('@/assets/img/default/user-image.png');

const getAvailableTabs = (role) => {
  const baseTabs = [];

  const financeRoles = [
    'finance_head',
    'tax_support',
    'billing_supervisor',
    'vice_president_finance',
  ];

  if (role === 'budget_controller') {
    baseTabs.push(
      { label: 'Address', value: 'address' },
      { label: 'Upload Legal Document', value: 'document' },
    );
  } else if (financeRoles.includes(role)) {
    baseTabs.push(
      { label: 'Sales Info', value: 'sales' },
      { label: 'Upload Legal Document', value: 'document' },
    );
  } else {
    baseTabs.push(
      { label: 'Details', value: 'details' },
      { label: 'Address', value: 'address' },
      { label: 'Sales Info', value: 'sales' },
      { label: 'Upload Legal Document', value: 'document' },
      { label: 'Loyalty Point', value: 'loyalty' },
    );
  }

  return baseTabs;
};

const contentLabel = [
  { label: `Business Tax Code ${isVn() ? '' : '(NPWP)'}`, value: 'npwp' },
  { label: `Identification Number ${isVn() ? '' : '(KTP)'}`, value: 'ktp' },
  { label: 'Delivery Address', value: 'delivery' },
  { label: 'Invoice Address', value: 'invoice' },
  { label: 'Store Address', value: 'store' },
];

const legalDocuments = {
  b2b: [
    { label: 'NPWP', key: 'npwp', required: true },
    { label: 'SPPKP', key: 'sppkp', required: true },
    { label: 'NIB', key: 'nib' },
    { label: 'Akta Direksi Perusahaan', key: 'akta_direksi_perusahaan' },
    { label: 'KTP', key: 'ktp', required: true },
    { label: 'Form New Customer', key: 'form_new_customer', required: true },
    { label: 'Kartu Keluarga', key: 'kartu_keluarga' },
    {
      label: 'Surat Ketentuan Perdagangan',
      key: 'surat_ketentuan_perdagangan',
      required: true,
    },
    { label: 'Anggaran Dasar Perusahaan', key: 'anggaran_dasar_perusahan' },
    {
      label: 'Pengesahan Kementrian Hukum dan HAM',
      key: 'pengesahan_kemenhum_ham',
    },
    {
      label: 'Add Trading Terms',
      key: 'trading_terms',
    },
    {
      label: 'Other File',
      key: 'other_file',
    },
  ],
  b2b_vn: [
    {
      label: 'Enterprise Registration Certificate (ERC)',
      key: 'erc',
      required: true,
    },
    { label: 'Power of Attorney (PoA)', key: 'poa' },
    {
      label: 'Agreement/Trading terms',
      key: 'form_new_customer',
      required: true,
    },
    {
      label: 'Other File',
      key: 'other_file',
    },
  ],
};

const defaultLimit = isWeb ? 10 : 15;

function CustomerDetail(props) {
  const dimension = Dimensions.get('screen');
  const tableRef = useRef();
  const creditLimitRef = useRef();
  const isInitialMount = useRef(true);
  const [customer, setCustomer] = useState({});
  const [customerCluster, setCustomerCluster] = useState({});
  const [businessType, setBusinessType] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalAddress, setModalAddress] = useState(false);
  const [modalLog, setModalLog] = useState(false);
  const [modalReject, setModalReject] = useState(false);
  const [modalLoyalty, setModalLoyalty] = useState(false);
  const [address, setAddress] = useState(null);
  const [lastStatus, setLastStatus] = useState(null);
  const [loyaltyLogs, setLoyaltyLogs] = useState([]);
  const [loadingLoadMore, setLoadingLoadMore] = useState(false);
  const [creditLimit, setCreditLimit] = useState('Not Set');
  const [showCreditLimitModal, setShowCreditLimitModal] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [npwpDataAddress, setNpwpDataAddress] = useState({});
  const [ktpDataAddress, setKtpDataAddress] = useState({});
  const [deliveryAddress, setDeliveryDataAddress] = useState([]);
  const [storeDataAddress, setStoreDataAddress] = useState([]);
  const [invoiceAddress, setInvoiceDataAddress] = useState([]);
  const [addressModalType, setAddressModalType] = useState('');
  const [signatures, setSignatures] = useState({
    prepared_by: null,
    acknowledge_by: null,
    customer_by: null,
  });
  const [paramsLogs, setParamsLogs] = useState({
    limit: defaultLimit,
    skip: 0,
  });
  const [average, setAverage] = useState({
    average: 0,
    cluster: '',
  });
  const [showAll, setShowAll] = useState(false);
  const [showImageOptions, setShowImageOptions] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showComments, setShowComments] = useState(
    props?.route?.params?.openComments === 'true',
  );
  const [headerMenu, setHeaderMenu] = useState(null);

  const prev_page = props?.route?.params?.prev_page;
  const customerId = props?.route?.params?.id;
  const skpId = props?.route?.params?.skp_id;
  const orderId = props?.route?.params?.order_id;
  const rptId = props?.route?.params?.rpt_id;
  const orderType = props?.route?.params?.order_type;
  const referenceCode = props?.route?.params?.reference_code;

  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const roleUser = auth?.user?.role.code;

  const tabs = useMemo(() => getAvailableTabs(roleUser), [roleUser]);
  const [tabActive, setTabActive] = useState(tabs[0]?.value || 'details');

  const hasAccessEditLoyalty = !hasNoAccess([
    'sales_supervisor',
    'branch_head',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'superadmin',
    'finance_supervisor',
    'general',
    'regional_distributor_manager',
  ]);
  const hasAccessEditDraft = !hasNoAccess([
    'superadmin',
    'salesman',
    'sales_admin',
    'general',
  ]);
  const hasAccessEditApproved = !hasNoAccess(['superadmin', 'general']);
  const hasAccessEditRejected = !hasNoAccess([
    'superadmin',
    'sales_admin',
    'general',
  ]);
  const hasAccessUpload = !hasNoAccess([
    'sales_admin',
    'salesman',
    'superadmin',
    'sales_supervisor',
    'chief_of_staff',
    'general',
    // 'beauty_advisor',
    // 'merchandiser',
  ]);
  const hasAccessStatus = useMemo(() => {
    return Boolean(!hasNoAccess(['superadmin', 'general']));
  }, [customer]);
  const hasAccessSubdis = !hasNoAccess([
    'superadmin',
    'general',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'chief_of_staff',
  ]);

  const hasAccessExportPDF = !hasNoAccess([
    'superadmin',
    'general',
    'sales_admin',
    'branch_head',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'vice_president',
    'general_manager_marketing',
    'chief_of_staff',
    'regional_distributor_manager',
  ]);

  const hasAccessEditSignatures = !hasNoAccess([
    'superadmin',
    'sales_admin',
    'salesman',
    'branch_head',
    'distributor_manager',
    'vice_president',
    'regional_distributor_manager',
  ]);

  const showEdit = useMemo(() => {
    const status = customer?.status || '';
    if (status === 'draft') {
      return hasAccessEditDraft;
    } else if (status === 'rejected') {
      return hasAccessEditRejected;
    } else if (status === 'approved') {
      return hasAccessEditApproved;
    }
  }, [
    customer,
    hasAccessEditDraft,
    hasAccessEditRejected,
    hasAccessEditApproved,
  ]);

  const canApprove = useMemo(() => {
    let show = false;
    const userRole = auth?.user?.role?.code;
    if (customer?.status == 'need_approval') {
      const listApprovals = customer?.approvals;
      if (listApprovals?.length) {
        show = Boolean(
          customer?.current_approval == userRole &&
            listApprovals?.find(
              (a) => a.id == auth.userId || a.role == userRole,
            ),
        );
      }
    }
    return show;
    // const status = customer?.status || '';
    // if (customer?.list_approval?.length && status === 'need_approval') {
    //   return Boolean(customer.list_approval.find((x) => x.id === auth.userId));
    // } else {
    //   return false;
    // }
  }, [auth, customer, customerCluster]);

  const logs = useApi(getLoyaltyCustomers);
  const totalInvoice = useApi(getCustomerTotalInvoice);
  const salesCount = useApi(getSalesOrderCount);

  const customerNameStyle = useMemo(() => {
    let style = { width: '100%' };
    const showEditButton = tabActive !== 'loyalty' && showEdit;
    if (isWeb && (showEditButton || hasAccessStatus)) {
      if (hasAccessStatus && showEditButton && !isVn()) {
        if (hasAccessExportPDF) {
          style = { width: 'calc(100% - 250px)' };
        } else {
          style = { width: 'calc(100% - 210px)' };
        }
      } else {
        if (isVn()) {
          style = { width: 'calc(100% - 210px)' };
        } else {
          style = { width: 'calc(100% - 160px)' };
        }
      }
    } else {
      if (hasAccessExportPDF && !isVn() && isWeb) {
        if (!hasAccessStatus) {
          style = { width: 'calc(100% - 220px)' };
        }
      }
    }
    return style;
  }, [tabActive, hasAccessStatus, showEdit]);

  const parseLogsData = (res, params = null) => {
    if (res.status === 200 && res.data?.data) {
      const allData = res.data.data.map((log) => {
        const date = format(parseISO(log.created_at), 'dd MMM yyyy');
        const img = log.created_by?.image || '';
        const user_name = log.created_by?.name || '';
        const status = generateStatus('price_rules', log.state, 'value');
        return {
          ...log,
          date,
          img,
          user_name,
          statusDetail: status,
        };
      });
      if (params) {
        setLoyaltyLogs([...loyaltyLogs, ...allData]);
      } else {
        setLoyaltyLogs(allData);
      }
      return;
    }
    setLoyaltyLogs([]);
  };

  const callback = (data) => {
    if (data.key === 'editLoyalty') {
      setModalLoyalty(true);
    } else if (data.key === 'edit') {
      props.navigation.navigate('CustomerRegisterNavigator', {
        screen: 'CustomerRegistrationScreen',
        params: {
          id: customerId,
        },
      });
    } else if (data.key === 'status') {
      alertStatus(data.data);
    } else if (data.key === 'pdf' && !isVn()) {
      onExportPdf(customerId);
    } else {
      changeTab(data.key, null, data.status);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const onSearchTable = (param, type) => {
    const params = { ...paramsLogs };
    if (type === 'pagination') {
      setLoadingLoadMore(true);
      params.limit = param.limit;
      params.skip = param.skip;
    }
    setParamsLogs(params);
    changePoint(params);
  };

  const changeTab = (tab, data = null, status = '') => {
    const customerData = data ? data : customer;
    let cusStatus = status;
    if (customerData?.status) {
      cusStatus = customerData.status;
    }
    setTabActive(tab);
    try {
      setTimeout(() => {
        props.navigation.setParams({ tab });
      }, 500);
    } catch (error) {}
    let menu = [
      { type: 'props', name: 'Edit', key: 'edit' },
      { type: 'props', name: 'Upload Legal Document', key: 'document' },
      {
        type: 'props',
        name: 'Loyalty Point',
        key: 'loyalty',
        status: (customerData && customerData.status) || '',
      },
    ];
    if (tab === 'loyalty') {
      menu = [{ type: 'props', name: 'Edit Point', key: 'editLoyalty' }];
    }
    if (hasAccessExportPDF) {
      menu.push({
        type: 'props',
        name: 'Export PDF',
        key: 'pdf',
        status: (customerData && customerData.status) || '',
      });
    }
    if (
      (cusStatus === 'draft' && !hasAccessEditDraft) ||
      (cusStatus === 'rejected' && !hasAccessEditRejected) ||
      (cusStatus === 'approved' && !hasAccessEditApproved) ||
      cusStatus === 'need_approval'
    ) {
      menu = menu.filter((x) => x.key !== 'edit');
    }

    if (cusStatus !== 'approved' || !hasAccessEditLoyalty) {
      menu = menu.filter((x) => x.key !== 'editLoyalty');
    }

    // Add action status
    if (!hasNoAccess(['superadmin', 'sales_supervisor', 'general'])) {
      menu.push({
        type: 'props',
        name: customerData.is_active ? 'In Active' : 'Active',
        key: 'status',
        data: customerData.is_active,
      });
    }

    if (!isWeb) {
      setHeaderMenu(menu);
    }
  };

  // Mobile header: Comment + More, same as the Sales Order / SKP Internal detail headers.
  // Set from an effect rather than inside changeTab so the Comment button's unread dot
  // always sees the current drawer state.
  useEffect(() => {
    if (isWeb || !headerMenu) {
      return;
    }
    const windowWidth = Dimensions.get('window').width;
    props.navigation.setOptions({
      // [B2B-5891][B2B-5924] Two header buttons (~50px each) leave less room than the default
      // title maxWidth assumes: Back 50 + title margins 16/16 + Comment 50 + More 50 = 182px.
      headerTitleStyle: customer._id
        ? getHeaderTitleStyle(windowWidth - 182)
        : undefined,
      headerRight: () => (
        <View style={styles.headerRightRow}>
          {customer._id ? (
            <CommentHeaderButton
              onPress={() => setShowComments(true)}
              drawerVisible={showComments}
              entityType="customer"
              entityId={customer._id}
            />
          ) : (
            false
          )}
          {headerMenu.length > 0 ? (
            <MoreButton
              testID="customer-detail-more-btn"
              menu={headerMenu}
              callback={(value) => callback(value)}
            />
          ) : (
            false
          )}
        </View>
      ),
    });
  }, [headerMenu, showComments, customer._id]);

  const onPressAddress = (addressType) => (data) => {
    setAddress({
      ...data.data,
      addressType: data.type,
    });
    setAddressModalType(addressType);
    setModalAddress(true);
  };

  const onTogglePremium = async (addressData, value) => {
    try {
      await updateCustomerAddressPremium(customerId, addressData.address_id, {
        address_type: addressData.addressType,
        is_premium: value,
      });
      setAddress({ ...addressData, is_premium: value });
      const setDataAddress =
        addressData.addressType === 'delivery'
          ? setDeliveryDataAddress
          : setStoreDataAddress;
      setDataAddress((prev) =>
        prev.map((item) =>
          item.address_id === addressData.address_id
            ? { ...item, is_premium: value }
            : item,
        ),
      );
      Toast.show({ text1: 'Premium status updated', type: 'success' });
    } catch (e) {
      Toast.show({ text1: getErrorMessage(e), type: 'error' });
    }
  };

  const upload = async (type) => {
    if (isWeb) {
      const attach = await getDocumentAsync({
        copyToCacheDirectory: false,
      });
      if (!attach.canceled) {
        if (!isAllowedAttachmentFormat(attach.assets[0])) {
          dispatch(
            showAlert({
              show: true,
              title: ATTACHMENT_FORMAT_ERROR_TITLE,
              description: ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
              isConfirm: false,
            }),
          );
          return;
        }
        dispatch(showPopup({ name: 'isLoading', value: true }));
        try {
          const url = await uploadS3({
            file: attach.assets[0] || {},
            isNeedMobileSupport: true,
          });
          if (url) {
            uploadDocument({ documents: [{ type, url }] });
          } else {
            Toast.show({
              text1: 'Failed to upload file. Please try again.',
              type: 'error',
            });
          }
          dispatch(showPopup({ name: 'isLoading', value: false }));
        } catch (err) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
        }
      }
    } else {
      setShowImageOptions(true);
      setSelectedDocument(type);
    }
  };

  const uploadDocument = async (payload, deleted = false) => {
    setLoading(true);
    try {
      let response = {};
      let label = 'uploaded';
      if (deleted) {
        response = await deleteCustomerDocumentsById(customer._id, payload);
        label = 'deleted';
      } else {
        response = await updateCustomerDocumentsById(customer._id, payload);
      }
      let result = response.data.data;
      if (Array.isArray(response.data.data)) {
        result = response.data.data[0];
      }
      setCustomer(result);
      setLoading(false);
      Toast.show({ text1: 'Document Successfully ' + label, type: 'success' });
    } catch (e) {
      setLoading(false);
      Toast.show({
        text1: 'Something Wrong, please try again.',
        type: 'error',
      });
    }
  };

  const deleteDocument = (id) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Remove Document',
        description: 'This document will be deleted. Do you want to proceed?',
        onCallback: () => uploadDocument(id, true),
      }),
    );
  };

  const onDownload = (url) => {
    if (url) {
      if (
        ['image/jpeg', 'image/png', 'image/svg+xml'].includes(
          generateMimeType(url),
        )
      ) {
        dispatch(
          showImage({
            isModal: true,
            isMultiple: true,
            allImage: [url],
            url: url,
            noArrow: true,
          }),
        );
      } else {
        downloadFile(url, 'customer-legal-document', '', true, true);
      }
    }
  };

  const changeState = async (reason) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    const payload = {};
    let state = 'approved';
    try {
      if (reason) {
        payload.reason = reason;
        state = 'rejected';
      }
      await updateCustomerStateById(customer._id, state, payload);
      await getCustomer();
      dispatch(showPopup({ name: 'isLoading', value: false }));
      //props.navigation.navigate('HomeNavigator');
      Toast.show({ text1: 'Customer registration ' + state, type: 'success' });
      setModalReject(false);
    } catch (e) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: 'Something Wrong, please try again.',
        type: 'error',
      });
    }
  };

  const onExportPdf = async (id = '') => {
    if (id) {
      try {
        dispatch(showPopup({ name: 'isLoading', value: true }));

        await exportPdf('customer', id);

        dispatch(showPopup({ name: 'isLoading', value: false }));
      } catch (error) {
        console.log(error);
        Toast.show({
          text1: 'Something Wrong, please try again.',
          type: 'error',
        });
      }
    }
  };

  const changeStatus = async (is_active) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      await updateCustomerStatusById(customer._id || customerId, { is_active });
      await getCustomer();
      setTimeout(() => {
        Toast.show({
          text1: `Successfully update status to ${
            is_active ? 'Active' : 'Inactive'
          }`,
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }, 500);
    } catch (e) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: getErrorMessage(e),
        type: 'error',
      });
    }
  };

  const alertStatus = (is_active) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Change Status',
        description: `This customer status will be ${
          is_active ? 'In Active' : 'Active'
        }. Do you want to proceed?`,
        onCallback: () => changeStatus(!is_active),
      }),
    );
  };

  const getCreditLimit = async (customer) => {
    try {
      const response = await MsAccount.getCreditLimit({
        params: {
          filter: {
            is_active: true,
            'payment_terms.id': customer.payment_terms?.id,
            'market_type.code': {
              $in: [
                customer.market_type?.code?.toUpperCase(),
                customer.market_type?.code?.toLowerCase(),
              ],
            },
          },
        },
      });
      if (response?.data?.data?.length) {
        const creditLimit = AUTOMATE_CREDIT_LIMIT.find(
          (el) => el.value == response.data.data[0].automate_credit_limit,
        );
        setCreditLimit(creditLimit?.label || 'Not Set');
      }
    } catch (error) {}
  };

  const resetDataAddress = () => {
    //reset payload
    setKtpAddress({});
    setNpwpAddress({});
    setDeliveryAddress([]);
    setStoreAddress([]);
    setInvoiceAddress([]);

    //reset state
    setInvoiceDataAddress([]);
    setDeliveryDataAddress([]);
    setStoreDataAddress([]);
    setKtpDataAddress({});
    setNpwpDataAddress({});
  };

  const updateSignaturesCustomer = async (payload) => {
    try {
      const fixedPayload = {
        ...payload,
      };
      dispatch(showPopup({ name: 'isLoading', value: true }));
      await updateCustomerSignaturesById(customerId, fixedPayload);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'Successfully update signatures', type: 'success' });
      //fetch
      getCustomer(false);
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: 'Something Wrong, please try again.',
        type: 'error',
      });
    }
  };

  const getCustomer = (shouldReset = true) => {
    setShowAll(false);
    getCustomerId(customerId)
      .then((res) => {
        resetDataAddress();
        if (!res.data.data) {
          setLoading(false);
          return;
        }
        if (shouldReset) {
          totalInvoice.request(customerId);
          salesCount.request({
            params: {
              filter: { 'customer.id': customerId },
            },
          });
        }
        const cus = res.data.data;

        if (shouldReset) {
          getCreditLimit(cus);
        }
        let status = '';
        // let list = [];
        // const current_approve = cus.current_approval
        //   ? cus.current_approval
        //   : cus.current_cluster_approval
        //     ? cus.current_cluster_approval
        //     : '';
        // if (current_approve && cus?.approvals?.length) {
        //   list = cus.approvals.filter((x) => x.role === current_approve);
        // }
        if (res.data.data.status) {
          if (shouldReset) {
            status = generateStatus(
              'price_rules',
              res.data.data.status,
              'value',
            );
            setStatus(status);
          }
          setSignatures({
            customer_by: null,
            acknowledge_by: null,
            prepared_by: null,
            created_at: null,
          });
          if (shouldReset) {
            setCustomer({ ...res.data.data, statusDetail: status });
          }
          if (res.data?.data?.signatures) {
            setSignatures(res.data?.data?.signatures);
          }
        }

        setInvoiceDataAddress(res.data.data?.invoice_address ?? []);
        setDeliveryDataAddress(res.data.data?.delivery_address ?? []);
        setStoreDataAddress(res.data.data?.store_address ?? []);
        if (res.data.data.vat_address) {
          setNpwpDataAddress({
            ...res.data.data.vat_address,
            vat: res.data.data.vat_address?.identification_number ?? '',
          });
        } else if (res.data.data.vat) {
          setNpwpDataAddress({
            vat: res.data.data?.vat ?? '',
          });
        }

        if (res.data.data.ktp_address) {
          setKtpDataAddress({
            ...res.data.data.ktp_address,
            ktp: res.data.data.ktp_address?.identification_number ?? '',
          });
        } else if (res.data.data.ktp) {
          setKtpDataAddress({
            ktp: res.data.data?.ktp ?? '',
          });
        }

        if (!shouldReset) {
          setLoading(false);
          return;
        }
        if (res.data.data.state_histories?.length) {
          const last =
            res.data.data.state_histories[
              res.data.data.state_histories.length - 1
            ];
          setLastStatus({
            ...last,
            name: last.status_changed_by?.name || '',
            img: last.status_changed_by?.image || '',
          });
        }
        setCustomer({
          ...cus,
          list_approval: cus.approvals,
          statusDetail: status,
        });

        const allowedTabs = getAvailableTabs(roleUser).map((t) => t.value);
        const routeTab = props.route?.params?.tab;
        const selectedTab = allowedTabs.includes(routeTab)
          ? routeTab
          : allowedTabs[0];

        changeTab(selectedTab, res.data.data);

        getMarketType(cus);
        getCluster(customerId);
        fetchSalesTeamPersonsIfMissing(cus);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Toast.show({
          text1: 'Something Wrong, please try again.',
          type: 'error',
        });
      });
  };

  const fetchSalesTeamPersonsIfMissing = async (cus) => {
    if (!cus.sales_team?.id) {
      return;
    }
    const fetchByRole = async (roleCode) => {
      try {
        const res = await MsAccount.getUsers({
          params: {
            filter: {
              is_active: true,
              'role.code': roleCode,
              'sales_team.id': cus.sales_team.id,
            },
            limit: 100,
          },
        });
        if (res?.status === 200 && res.data?.data?.length) {
          return res.data.data.map((u) => ({ id: u._id, name: u.name }));
        }
        return [];
      } catch (e) {
        return [];
      }
    };
    const updates = {};
    // [B2B-5933] Sales Admin is chosen by the user (mandatory), so an empty one is no longer auto-filled
    if (!cus.regional_distributor_manager?.length) {
      updates.regional_distributor_manager = await fetchByRole(
        'regional_distributor_manager',
      );
    }
    if (Object.keys(updates).length) {
      setCustomer((prev) => ({ ...prev, ...updates }));
      try {
        await patchCustomerSalesTeamPersons(cus._id, updates);
      } catch (e) {
        // display already updated locally; persist failure is non-critical
      }
    }
  };

  const getMarketType = async (cus) => {
    const marketTypeId = cus?.market_type?.id;

    if (marketTypeId) {
      try {
        const mtData = await MsB2b.getMarketTypeDetail(marketTypeId);
        const mt = mtData.data.data;
        const btData = mt?.business_type.find(
          (v) => v._id == cus?.market_type?.business_type?.id,
        );
        let bt = cus?.market_type?.business_type?.code;
        if (btData && btData?.description) {
          bt = `${btData.code} (${btData.description})`;
        }

        setBusinessType(bt);
      } catch (e) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }
    } else {
      dispatch(showPopup({ name: 'isLoading', value: false }));
    }
  };

  const getCluster = async (id = null) => {
    const average = { average: 0, cluster: '' };
    try {
      if (id) {
        const response = await getClusterByCustomerId(id);
        average.average = response.data.data?.average_purchase_amount || 0;
        average.cluster = response.data.data?.cluster?.name || '';
        if (response?.data?.data?._id) {
          setCustomerCluster(response.data.data);
        }
      } else {
        dispatch(showPopup({ name: 'isLoading', value: true }));
        const response = await getCustomerAveragePurchase(customerId);
        average.average = response.data.data?.averageTotalPurchaseAmount || 0;
        average.cluster = response.data.data?.cluster?.name || '';
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }
    } catch (e) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
    }
    setAverage(average);
  };

  const changePoint = (param) => {
    logs
      .request({
        params: {
          filter: { 'user.id': props.route.params.id },
          limit: param ? param.limit : defaultLimit,
          skip: param ? param.skip : 0,
          sort: '-_id',
        },
      })
      .then((res) => {
        setLoyaltyLogs([]);
        parseLogsData(res, param);
        setModalLoyalty(false);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        setLoadingLoadMore(false);
      });
  };

  const getDocumentLabel = (key, url) => {
    const allDocs = [...legalDocuments.b2b, ...legalDocuments.b2b_vn];
    const label = allDocs.find((doc) => doc.key === key)?.label;

    let fileType = '';
    try {
      const pathname = new URL(url).pathname;
      const match = pathname.match(/\.(\w{2,5})(?:\?|$)/);
      fileType = match ? match[1] : '';
    } catch (e) {
      fileType = '';
    }

    if (!fileType) {
      const contentType = generateMimeType(url);
      fileType = contentType?.split('/')[1] || 'file';
    }

    return label ? `${label}.${fileType}` : '-';
  };

  const ButtonUpload = (buttonProps) => {
    const isOtherFile = buttonProps.type === 'other_file';
    const docs = (customer.documents || []).filter(
      (x) => x.type === buttonProps.type,
    );

    const renderDocItem = (doc) => (
      <View key={doc._id} style={styles.documentItemContainer}>
        <View style={styles.documentItemList}>
          <SociollaText
            numberOfLines={isWeb ? 2 : 1}
            ellipsizeMode="tail"
            style={{ fontSize: 12, color: Colors.grey1, textAlign: 'left' }}>
            {getDocumentLabel(buttonProps.type, doc.url)}
          </SociollaText>
        </View>

        <TouchableOpacity
          testID={`customer-detail-download-doc-${doc._id}`}
          style={{ marginLeft: 10 }}
          onPress={() => onDownload(doc.url)}>
          <Image
            style={{ width: 24, height: 24 }}
            width={24}
            height={24}
            isResolveAsset
            source={require('@/assets/img/icons/attachment.png')}
          />
        </TouchableOpacity>

        {hasAccessUpload && (
          <TouchableOpacity
            testID={`customer-detail-delete-doc-${doc._id}`}
            style={{ marginLeft: 12 }}
            onPress={() => deleteDocument(doc._id)}>
            <Image
              style={{ width: 20, height: 20 }}
              width={20}
              height={20}
              svg
              source={require('@assets/img/icons/close-circle-grey.svg')}
            />
          </TouchableOpacity>
        )}
      </View>
    );

    const shouldShowUploadButton =
      hasAccessUpload && (isOtherFile || (!isOtherFile && docs.length === 0));

    return (
      <View style={{ marginLeft: isWeb ? 20 : 0 }}>
        {isOtherFile
          ? docs.map(renderDocItem)
          : docs[0]?.url && renderDocItem(docs[0])}

        {shouldShowUploadButton && (
          <Button
            testID={`customer-detail-upload-${buttonProps.type}-btn`}
            type="grey"
            rounded={true}
            buttonStyle={{ width: 70 }}
            title={
              <SociollaText style={{ fontSize: 10, color: Colors.black }}>
                Upload
              </SociollaText>
            }
            onPress={() => upload(buttonProps.type)}
          />
        )}
      </View>
    );
  };

  const User = (userProps) => {
    return (
      <View
        style={
          isWeb
            ? {
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                ...userProps.style,
              }
            : {
                flexDirection: 'row',
                justifyContent: 'flex-start',
                paddingBottom: 10,
              }
        }
        key={'list-users-' + userProps.index}>
        <Image
          style={{ width: 20, height: 20, marginRight: 8 }}
          width={20}
          height={20}
          isResolveAsset
          source={userProps.image ? userProps.image : img}
        />
        <SociollaText
          style={{ fontSize: 12, color: '#171D29', alignSelf: 'center' }}>
          {userProps.name}
        </SociollaText>
      </View>
    );
  };

  const logItem = ({ item, index }) => (
    <TouchableOpacity
      testID={`customer-detail-loyalty-log-item-${index}`}
      key={'log-list-' + index}
      style={[
        styles.row,
        { justifyContent: 'flex-start', paddingVertical: 14 },
        loyaltyLogs.length === index + 1
          ? {}
          : { borderBottomWidth: 1, borderBottomColor: Colors.grey0 },
        isWeb ? { alignItems: 'center' } : { flexDirection: 'column' },
      ]}>
      {isWeb ? (
        <>
          <View style={[styles.row, { flex: 1 }]}>
            <Image
              style={{ width: 16, height: 16, marginRight: 8 }}
              width={16}
              height={16}
              svg={true}
              source={require('@assets/img/icons/menu/calendar.svg')}
            />
            <SociollaText style={{ fontSize: 12, color: Colors.black5 }}>
              {item.date}
            </SociollaText>
          </View>
          <View style={[styles.row, { flex: 2, alignItems: 'center' }]}>
            <Image
              style={{ width: 20, height: 20, marginRight: 6 }}
              width={20}
              height={20}
              source={item.img ? item.img : img}
            />
            <SociollaText
              style={{ fontSize: 12, color: Colors.blue3 }}
              numberOfLines={1}>
              {item.user_name}
            </SociollaText>
          </View>
          <SociollaText
            style={{ fontSize: 12, color: Colors.black3, flex: 2 }}
            numberOfLines={1}>
            {item.notes}
          </SociollaText>
          <SociollaText
            style={{
              flex: 1,
              fontSize: 12,
              color: Colors.black1,
              backgroundColor: item.statusDetail?.color
                ? item.statusDetail.color
                : 'none',
              width: 'auto',
              textAlign: 'center',
              paddingVertical: 7,
              borderRadius: 4,
              paddingHorizontal: 12,
              alignSelf: 'flex-start',
            }}>
            {item.statusDetail?.label || ''}
          </SociollaText>
          <SociollaText
            style={{
              fontSize: 16,
              color: Colors.blue3,
              textAlign: 'right',
              flex: 0.5,
              alignSelf: 'flex-end',
            }}>
            {item.points}
          </SociollaText>
        </>
      ) : (
        <View style={[styles.row, { width: '100%' }]}>
          <View style={{ flex: 1 }}>
            <View style={styles.row}>
              <Image
                style={{ width: 16, height: 16, marginRight: 8 }}
                width={16}
                height={16}
                svg={true}
                source={require('@assets/img/icons/menu/calendar.svg')}
              />
              <SociollaText
                style={{
                  fontSize: 12,
                  color: Colors.black5,
                  alignSelf: 'center',
                }}>
                {item.date}
              </SociollaText>
            </View>
            <SociollaText
              style={{ fontSize: 12, color: Colors.black3, marginTop: 8 }}
              numberOfLines={3}>
              {item.notes}
            </SociollaText>
          </View>
          <View style={{ flex: 1, alignItems: 'flex-end' }}>
            <SociollaText
              style={{
                fontSize: 12,
                color: Colors.black1,
                backgroundColor: item.statusDetail?.color
                  ? item.statusDetail.color
                  : 'none',
                textAlign: 'center',
                paddingVertical: 7,
                borderRadius: 4,
                paddingHorizontal: 12,
              }}>
              {item.statusDetail?.label || ''}
            </SociollaText>
            <View style={[styles.row, { marginTop: 8 }]}>
              <Image
                style={{ width: 20, height: 20, marginRight: 6 }}
                width={20}
                height={20}
                source={item.img ? item.img : img}
              />
              <SociollaText
                style={{
                  fontSize: 12,
                  color: Colors.blue3,
                  alignSelf: 'center',
                }}
                numberOfLines={1}>
                {item.user_name}
              </SociollaText>
            </View>
            <SociollaText
              style={{
                fontSize: 16,
                color: Colors.blue3,
                textAlign: 'right',
                marginTop: 8,
              }}>
              {item.points}
            </SociollaText>
          </View>
        </View>
      )}
    </TouchableOpacity>
  );

  const goBack = () => {
    if (prev_page == 'loyalty') {
      props.navigation.navigate('LoyaltyNavigator', {
        screen: 'LoyaltyScreen',
      });
    } else if (prev_page == 'task') {
      props.navigation.navigate('TaskNotificationNavigator', {
        screen: 'TaskNotificationScreen',
        params: {
          task: true,
        },
      });
    } else if (prev_page == 'skp-external') {
      props.navigation.navigate('SkpExternalNavigator', {
        screen: 'SkpExternalDetailScreen',
        params: {
          id: skpId,
          titleScreen: referenceCode,
          name: customer.name,
        },
      });
    } else if (prev_page == 'sales-order') {
      props.navigation.navigate('SalesOrderNavigator', {
        screen: 'SalesOrderDetailScreen',
        params: {
          id: orderId,
          titleScreen: referenceCode,
          name: customer && customer.name ? customer.name : '-',
          order_type: orderType,
        },
      });
    } else if (prev_page == 'rpt') {
      props.navigation.navigate('RequestProductNavigator', {
        screen: 'RequestProductDetailScreen',
        params: {
          id: rptId,
          reference_code: referenceCode,
        },
      });
    } else {
      props.navigation.navigate('CustomerNavigator', {
        screen: 'CustomerScreen',
        params: {
          isHome: false,
        },
      });
    }
  };

  const handleChangeSubdis = async () => {
    const newIsSubdis = !customer.is_sub_distributor;
    dispatch(
      showAlert({
        show: true,
        isModal: true,
        title: `${newIsSubdis ? 'Set' : 'Remove'} Customer As Sub Distributor`,
        description: `Are you sure you want to ${
          newIsSubdis ? 'set' : 'remove'
        } this customer as a sub distributor?`,
        onCallback: async () => {
          try {
            const response = await MsAccount.toggleCustomerSubdis(
              customer._id,
              {
                is_sub_distributor: newIsSubdis,
              },
            );
            if (response?.data?.data) {
              Toast.show({
                text1: newIsSubdis
                  ? 'Customer is set as sub distributor'
                  : 'Customer is removed as sub distributor',
              });
              setCustomer((prevState) => ({
                ...prevState,
                is_sub_distributor: newIsSubdis,
              }));
            }
          } catch (error) {
            Toast.show({
              text1: 'Something Wrong, please try again.',
              type: 'error',
            });
            console.log(error);
          }
        },
      }),
    );
  };

  useEffect(() => {
    if (!customerId) {
      return;
    }

    const fetchCustomerData = () => {
      setLoading(true);
      logs
        .request({
          params: {
            filter: { 'user.id': customerId },
            skip: 0,
            limit: defaultLimit,
            sort: '-_id',
          },
        })
        .then((res) => parseLogsData(res))
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
      getCustomer();
    };

    fetchCustomerData();

    const unsubscribe = props.navigation.addListener('focus', () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }

      if (customerId) {
        fetchCustomerData();
      }
    });

    return () => {
      unsubscribe();
      isInitialMount.current = true;
    };
  }, [customerId]);

  const validateDataAddress = (addressType) => {
    if (addressType === 'delivery') {
      return deliveryAddress.length > 0;
    }
    if (addressType === 'invoice') {
      return invoiceAddress.length > 0;
    }
    if (addressType === 'ktp') {
      return Object.keys(ktpDataAddress).length > 0;
    }
    if (addressType === 'store') {
      return storeDataAddress.length > 0;
    }

    return Object.keys(npwpDataAddress).length > 0;
  };

  const isNotIdentity = (addressType) => {
    return addressType !== 'ktp' && addressType !== 'npwp';
  };

  const renderLabel = (label) => (
    <SociollaText type="medium" style={styles.headerGridText}>
      {label}
    </SociollaText>
  );

  const renderHeaderGrid = ({ label, value }) => {
    const hasValue = validateDataAddress(value) && isNotIdentity(value);

    return (
      <View
        style={[
          styles.headerGridContainer,
          { justifyContent: hasValue ? 'space-between' : 'flex-start' },
        ]}>
        {renderLabel(label)}
      </View>
    );
  };

  const getDatAddress = (addressType) => {
    if (addressType === 'delivery') {
      return deliveryAddress;
    }
    if (addressType === 'invoice') {
      return invoiceAddress;
    }
    if (addressType === 'store') {
      return storeDataAddress;
    }
    if (addressType === 'ktp') {
      return [ktpDataAddress];
    }

    return [npwpDataAddress];
  };

  const renderDataAddress = (addressType) => {
    const dataAddress = getDatAddress(addressType);

    return (
      <Address
        addressType={addressType}
        data={dataAddress}
        hideDelete={true}
        onPressAddress={onPressAddress(addressType)}
      />
    );
  };

  const getBackgroundNoAddress = (addressType) => {
    let backgroundColor = 'rgba(29, 103, 252, 0.08)';

    switch (addressType) {
      case 'invoice':
        backgroundColor = 'rgba(252, 177, 29, 0.08)';
        break;
      case 'npwp':
        backgroundColor = '#E2F7E4';
        break;
      case 'ktp':
        backgroundColor = '#DEF1FF';
        break;
      default:
        backgroundColor = 'rgba(29, 103, 252, 0.08)';
        break;
    }

    return backgroundColor;
  };

  const getSmallerCardWidth = () => {
    if (!isWeb) {
      return 330;
    }

    const screenWidth = Dimensions.get('window').width;
    const maxContainerWidth = 1200;
    const effectiveWidth = Math.min(screenWidth, maxContainerWidth) - 160;
    const columns = 2;
    const spacing = 20;

    const totalGap = spacing * (columns - 1);
    const cardWidth = (effectiveWidth - totalGap) / columns;

    return Math.floor(cardWidth * 0.8);
  };

  const renderEmptyAddress = (addressType) => {
    const backgroundColor = getBackgroundNoAddress(addressType);

    return (
      <View
        key={addressType}
        style={[
          styles.gridItem,
          { backgroundColor },
          { width: getSmallerCardWidth() },
        ]}>
        <View style={styles.addAddressButton}>
          <SociollaText style={styles.addAddressText}>
            No Address Found
          </SociollaText>
        </View>
      </View>
    );
  };

  const renderAddressContent = (item) => {
    const { value: addressType } = item;
    const isNotEmptyAddress = validateDataAddress(addressType);

    return isNotEmptyAddress
      ? renderDataAddress(addressType)
      : renderEmptyAddress(addressType);
  };

  const renderContainerAddress = (item, idx) => (
    <View style={styles.containerAddress} key={idx}>
      {renderHeaderGrid(item)}
      {renderAddressContent(item)}
    </View>
  );

  const renderAddressCard = () => (
    <View style={styles.gridContainer}>
      {contentLabel.map((item, idx) => renderContainerAddress(item, idx))}
    </View>
  );

  const backButtonWeb = () => {
    return (
      isWeb && (
        <TouchableOpacity
          testID="customer-detail-back-btn"
          style={backSection}
          activeOpacity={0.6}
          onPress={() => goBack()}>
          <Image
            style={{ width: 7, height: 12, marginRight: 15 }}
            width={7}
            height={12}
            svg={true}
            source={require('@assets/img/icons/arrow-left-grey.svg')}
          />
          <SociollaText style={backSectionText}>
            Back to {prev_page === 'task' ? 'Task' : 'Customer'}
          </SociollaText>
        </TouchableOpacity>
      )
    );
  };

  const renderModalAddress = () => {
    return (
      modalAddress && (
        <ModalAddress
          testID="customer-detail-modal-address"
          show={modalAddress}
          onClose={() => {
            setAddress(null);
            setModalAddress(false);
            setAddressModalType('');
          }}
          view={true}
          data={address}
          addressType={addressModalType}
          modalType={addressModalType}
          onTogglePremium={onTogglePremium}
        />
      )
    );
  };

  const renderModalLoyalty = () => {
    return (
      modalLoyalty && (
        <ModalLoyalty
          testID="customer-detail-modal-loyalty"
          show={modalLoyalty}
          onClose={() => setModalLoyalty(false)}
          onSubmit={changePoint}
          data={{
            name: customer.name,
            point: customer.loyalty_points?.count || 0,
            id: customerId,
          }}
        />
      )
    );
  };

  const renderModalLog = () => {
    return (
      modalLog && (
        <ModalLog
          testID="customer-detail-modal-log"
          show={modalLog}
          status={customer.status}
          data={customer}
          onClose={() => setModalLog(false)}
          logType="customer"
          logId={customer._id}
          logLabel="Customer"
          logFormatter={CUSTOMER_LOG_FORMATTER}
        />
      )
    );
  };

  const renderModalReject = () => {
    return (
      modalReject && (
        <ModalReject
          testID="customer-detail-modal-reject"
          show={modalReject}
          onClose={() => setModalReject(false)}
          onSubmit={changeState}
        />
      )
    );
  };

  const modalCreditLimit = () => {
    return (
      showCreditLimitModal && (
        <ModalHalf
          testID="customer-detail-modal-credit-limit"
          spaceFromTop={isWeb ? modalPosition.top : 0}
          spaceFromLeft={isWeb ? modalPosition.left : 0}
          onClose={() => setShowCreditLimitModal(false)}
          visible={showCreditLimitModal}
          maxWidth={isWeb ? '30%' : '100%'}
          title={creditLimit}
          removePaddingBottom={true}
          titleStyle={{
            width: 'auto',
            fontFamily: 'figtree-regular',
          }}
          animationType={isWeb ? 'fade' : 'slide'}></ModalHalf>
      )
    );
  };

  const requestCameraPermission = async () => {
    try {
      if (isAndroid) {
        const PermissionsAndroid =
          Platform.OS === 'android'
            ? require('react-native').PermissionsAndroid
            : null;
        const granted = await PermissionsAndroid.request(
          PermissionsAndroid.PERMISSIONS.CAMERA,
          {
            title: 'App Camera Permission',
            message: 'App needs access to your camera',
            buttonNeutral: 'Ask Me Later',
            buttonNegative: 'Cancel',
            buttonPositive: 'OK',
          },
        );
        if (granted === PermissionsAndroid.RESULTS.GRANTED) {
          return true;
        } else {
          console.log('Camera permission denied');
          dispatch(
            showAlert({
              show: true,
              isModal: true,
              title: 'Permission denied',
              description: 'You need to give permission to access your camera',
              isConfirm: false,
            }),
          );
          return false;
        }
      } else if (isIos) {
        return true;
      }
    } catch (err) {
      console.warn(err);
      return false;
    }
  };

  async function launchCameraAsync(options) {
    return new Promise((resolve, reject) => {
      launchCamera(options, (res) => {
        if (res.didCancel) {
          resolve({ didCancel: true });
        } else if (res.errorCode) {
          reject(new Error(`ImagePicker Error: ${res.errorMessage}`));
        } else {
          resolve(res);
        }
      });
    });
  }

  async function manipulateImage({ image }) {
    const MAX_IMAGE_SIZE = 1 * 1024 * 1024;

    try {
      const isPortrait = image.height >= image.width;
      const FIXED_WIDTH_PORTRAIT = 1080;
      const FIXED_WIDTH_LANDSCAPE = 1920;

      const targetWidth = isPortrait
        ? FIXED_WIDTH_PORTRAIT
        : FIXED_WIDTH_LANDSCAPE;
      const targetHeight = Math.round(
        targetWidth * (image.height / image.width),
      );

      let normalized;

      if (isAndroid) {
        normalized = await manipulateAsync(
          image.uri,
          [
            {
              resize: {
                width: targetWidth,
                height: targetHeight,
              },
            },
          ],
          {
            compress: 1,
            format: SaveFormat.JPEG,
          },
        );
      } else {
        normalized = await manipulateAsync(image.uri, [], {
          compress: 1,
          format: SaveFormat.JPEG,
        });
      }

      let compressLevel = 1;
      let result = normalized;
      let fileInfo = await FileSystem.getInfoAsync(result.uri);

      while (fileInfo.size > MAX_IMAGE_SIZE && compressLevel > 0.85) {
        compressLevel -= 0.05;

        result = await manipulateAsync(result.uri, [], {
          compress: compressLevel,
          format: SaveFormat.JPEG,
        });

        fileInfo = await FileSystem.getInfoAsync(result.uri);
      }

      return {
        ...image,
        uri: result.uri,
        width: result.width,
        height: result.height,
      };
    } catch (error) {
      console.log('manipulateImage error:', error);
      return image;
    }
  }

  function resultImage(image) {
    try {
      const fileExtension = image?.uri.split('.').pop() ?? '';
      if (
        fileExtension &&
        /^.*(jpg|jpeg|png).*$/g.test(fileExtension.toLowerCase())
      ) {
        let filename =
          Math.floor(100000000000 * Math.random()) + '-' + Date.now();
        if (fileExtension.toLowerCase().includes('png')) {
          filename = filename + '.png';
          image.type = 'image/png';
        } else {
          filename = filename + '.jpg';
          image.type = 'image/jpeg';
        }
        return {
          uri: image.uri,
          filename,
          type: image.type,
        };
      }
      return false;
    } catch (error) {
      console.log('result-image', error);
      return false;
    }
  }

  async function takePicture() {
    try {
      const options = {
        saveToPhotos: false,
        mediaType: 'photo',
        includeBase64: false,
        quality: 1,
        includeExtra: true,
        ...(isAndroid
          ? {
              skipBackup: true,
              path: 'images',
              cameraRoll: true,
              waitUntilSaved: true,
            }
          : {}),
      };

      const isPermit = await requestCameraPermission();

      if (isPermit) {
        return new Promise((resolve) => {
          setTimeout(async () => {
            try {
              const res = await launchCameraAsync(options);

              if (res?.assets?.[0]) {
                const captured = res.assets[0];

                if (isAndroid) {
                  try {
                    const tags = await readAsync(captured.uri);
                    if (tags?.Orientation == 6 || tags?.Orientation == 8) {
                      const tempWidth = captured.width;
                      const tempHeight = captured.height;
                      captured.width = tempHeight;
                      captured.height = tempWidth;
                    }
                  } catch (error) {
                    console.log('error when handle rotation', error);
                  }
                }

                const finalUri = await manipulateImage({
                  image: captured,
                });
                // [B2B-5968] Save the camera shot to the gallery when Auto-save photos is on.
                savePhotoToGallery(finalUri?.uri);

                const result = resultImage(finalUri);
                resolve(result);
              } else {
                console.log('No image captured');
                resolve({});
              }
            } catch (error) {
              console.log('Error during camera launch or processing', error);
              resolve({});
            }
          }, 500);
        });
      } else {
        console.log('Permission denied');
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Permission denied',
            description: 'You need to give permission to access your camera',
            isConfirm: false,
          }),
        );
        return {};
      }
    } catch (error) {
      console.log('takePicture error', error);
      return {};
    }
  }

  async function chooseImagePicker() {
    try {
      const options = {
        mediaType: 'photo',
      };

      const result = await new Promise((resolve) =>
        launchImageLibrary(options, (response) => resolve(response)),
      );

      if (result && result.assets && result.assets.length > 0) {
        const picked = result.assets[0];

        if (isAndroid) {
          try {
            const tags = await readAsync(picked.uri);
            if (tags?.Orientation == 6 || tags?.Orientation == 8) {
              const tempWidth = picked.width;
              const tempHeight = picked.height;
              picked.width = tempHeight;
              picked.height = tempWidth;
            }
          } catch (error) {
            console.log('error when handle rotation', error);
          }
        }

        const finalUri = await manipulateImage({
          image: picked,
        });

        return resultImage(finalUri);
      }
      return false;
    } catch (error) {
      console.log('chooseImagePicker error', error);
      return false;
    }
  }

  async function chooseFromFile() {
    try {
      const res = await getDocumentAsync({
        copyToCacheDirectory: false,
        multiple: false,
      });

      if (!res.canceled && res.assets?.length > 0) {
        if (!isAllowedAttachmentFormat(res.assets[0])) {
          dispatch(
            showAlert({
              show: true,
              title: ATTACHMENT_FORMAT_ERROR_TITLE,
              description: ATTACHMENT_FORMAT_ERROR_DESCRIPTION,
              isConfirm: false,
            }),
          );
          return;
        }
        dispatch(showPopup({ name: 'isLoading', value: true }));

        try {
          const url = await uploadS3({
            file: res.assets[0],
            isNeedMobileSupport: true,
          });

          if (url) {
            uploadDocument({
              documents: [{ type: selectedDocument || 'other_file', url }],
            });
          } else {
            Toast.show({
              text1: 'Failed to upload file. Please try again.',
              type: 'error',
            });
          }
          dispatch(showPopup({ name: 'isLoading', value: false }));
        } catch (err) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Failed to upload file. Please try again.',
            type: 'error',
          });
        }
      }
    } catch (error) {
      console.log('chooseFromFile error', error);
    }
  }

  const pickFile = async (source = 'camera') => {
    setShowImageOptions(false);
    await new Promise((resolve) => setTimeout(resolve, 300));

    let outputFile;
    if (source === 'camera') {
      outputFile = await takePicture();
    } else if (source === 'gallery') {
      outputFile = await chooseImagePicker();
    } else if (source === 'file') {
      outputFile = await chooseFromFile();
      return;
    }

    if (outputFile && outputFile.uri) {
      const url = await uploadS3({
        file: outputFile,
        isImage: true,
      });
      if (url) {
        uploadDocument({
          documents: [{ type: selectedDocument || 'other_file', url }],
        });
      } else {
        Toast.show({
          text1: 'Failed to upload file. Please try again.',
          type: 'error',
        });
      }
      selectedDocument(null);
    }
  };

  const modalUploader = () => {
    return (
      <ModalHalf
        testID="customer-detail-modal-uploader"
        title=""
        visible={showImageOptions}
        maxWidth="100%"
        spaceFromTop={false}
        onClose={() => {
          setShowImageOptions(false);
          selectedDocument(null);
        }}>
        <View
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Button
            testID="customer-detail-take-photo-btn"
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Take photo
              </SociollaText>
            }
            onPress={() => pickFile('camera')}
          />
          <Button
            testID="customer-detail-choose-gallery-btn"
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Choose from gallery
              </SociollaText>
            }
            onPress={() => pickFile('gallery')}
          />
          <Button
            testID="customer-detail-choose-file-btn"
            type="grey"
            rounded
            buttonStyle={{ width: dimension.width - 40, marginVertical: 5 }}
            title={
              <SociollaText
                type="bold"
                style={{ fontSize: 14, color: Colors.blue10 }}>
                Choose from file
              </SociollaText>
            }
            onPress={() => pickFile('file')}
          />
          <View
            style={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 15,
              paddingTop: 15,
              borderTopColor: Colors.grey0,
              borderTopWidth: 1,
            }}>
            <Button
              testID="customer-detail-cancel-upload-btn"
              type="grey"
              rounded
              buttonStyle={{ width: dimension.width - 40 }}
              title={
                <SociollaText
                  type="bold"
                  style={{ fontSize: 14, color: Colors.red1 }}>
                  Cancel
                </SociollaText>
              }
              onPress={() => setShowImageOptions(false)}
            />
          </View>
        </View>
      </ModalHalf>
    );
  };

  const renderAllModal = () => (
    <>
      {renderModalAddress()}
      {renderModalLoyalty()}
      {renderModalLog()}
      {renderModalReject()}
      {modalUploader()}
      {modalCreditLimit()}
      <ModalImage showDefault={true} />
    </>
  );

  const renderTitle = (customerId, customer) => {
    return customerId
      ? `${customer?.name || 'Edit Customer'}`
      : 'Customer Registration';
  };

  const RejectButton = ({ onPress }) => (
    <Button
      testID="customer-detail-reject-btn"
      type="default"
      rounded
      buttonStyle={{ width: 120, marginRight: 15 }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.black }}>
          Reject
        </SociollaText>
      }
      onPress={onPress}
    />
  );

  const ConfirmButton = ({ onPress }) => (
    <Button
      testID="customer-detail-confirm-btn"
      rounded
      buttonStyle={{ width: 120 }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Confirm
        </SociollaText>
      }
      onPress={onPress}
    />
  );

  const renderButtons = (setModalReject, changeState) => (
    <View style={{ flexDirection: 'row' }}>
      <RejectButton onPress={() => setModalReject(true)} />
      <ConfirmButton onPress={() => changeState(null)} />
    </View>
  );

  const customerTitle = () => {
    if (isWeb && canApprove) {
      return (
        <Layout.Title title={renderTitle(customerId, customer)}>
          {renderButtons(setModalReject, changeState)}
        </Layout.Title>
      );
    }
  };

  const renderRejectButton = (setModalReject) => (
    <Button
      testID="customer-detail-mobile-reject-btn"
      type="default"
      rounded
      buttonStyle={{ width: '90%', alignSelf: 'center' }}
      disabledStyle={{ flex: 1 }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.black }}>
          Reject
        </SociollaText>
      }
      onPress={() => setModalReject(true)}
    />
  );

  const renderConfirmButton = (changeState) => (
    <Button
      testID="customer-detail-mobile-confirm-btn"
      rounded
      buttonStyle={{ width: '90%', alignSelf: 'center' }}
      disabledStyle={{ flex: 1 }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Confirm
        </SociollaText>
      }
      onPress={() => changeState(null)}
    />
  );

  const renderButtonContainer = (setModalReject, changeState) => (
    <View
      style={{
        ...buttonRow,
        ...buttonFloating,
        width: '100%',
        justifyContent: 'center',
      }}>
      {renderRejectButton(setModalReject)}
      {renderConfirmButton(changeState)}
    </View>
  );

  const approveButtons = () => {
    if (canApprove && !isWeb) {
      return renderButtonContainer(setModalReject, changeState);
    }
  };

  const SalesCard = ({ salesCount, customer, navigation }) =>
    !salesCount.loading && (
      <SociollaCard
        testID="customer-detail-sales-card"
        title={'Sales'}
        borderColor={false}
        titleStyle={{ fontSize: 22, color: Colors.black5 }}
        onPress={() =>
          navigation.navigate('SalesOrderNavigator', {
            screen: 'SalesOrderScreen',
            params: {
              customerId: customer?._id,
              titleScreen: customer?.name,
            },
          })
        }
        style={{
          minHeight: 153,
          borderTopWidth: 0,
          backgroundColor: Colors.blue9,
        }}>
        <CardText
          value={salesCount.error ? 0 : salesCount.data}
          currency={false}
        />
      </SociollaCard>
    );

  const InvoiceCard = ({ totalInvoice, customer, navigation }) =>
    !totalInvoice.loading && (
      <SociollaCard
        testID="customer-detail-invoice-card"
        title={'Invoice'}
        borderColor={false}
        titleStyle={{ fontSize: 22, color: Colors.black5 }}
        onPress={() =>
          navigation.navigate('SalesOrderNavigator', {
            screen: 'SalesOrderInvoiceScreen',
            params: {
              customerId: customer?._id,
              titleScreen: customer?.name,
            },
          })
        }
        style={{
          minHeight: 153,
          borderTopWidth: 0,
          backgroundColor: Colors.blue9,
        }}>
        <CardText
          value={totalInvoice.error ? 0 : totalInvoice.data}
          currency={true}
        />
      </SociollaCard>
    );

  const CardText = ({ value, currency }) => (
    <SociollaText
      type="medium"
      style={{
        fontSize: 28,
        color: Colors.black3,
        position: 'absolute',
        bottom: 16,
        right: 16,
      }}
      currency={currency}>
      {value}
    </SociollaText>
  );

  const renderRightHeader = () =>
    isWeb && (
      <View style={styles.rightContainer}>
        <SalesCard
          salesCount={salesCount}
          customer={customer}
          navigation={props.navigation}
        />
        <InvoiceCard
          totalInvoice={totalInvoice}
          customer={customer}
          navigation={props.navigation}
        />
      </View>
    );

  const getSociollaTabsStyle = (isWeb) => {
    return [
      isWeb
        ? { marginTop: 5, cursor: 'pointer' }
        : {
            borderTopWidth: 1,
            borderTopColor: Colors.grey9,
            paddingTop: 5,
          },
      { marginHorizontal: -20 },
    ];
  };

  const getSociollaTabsData = (isWeb, tabs) => {
    return isWeb ? tabs : tabs.slice(0, 3);
  };

  const shouldRenderTabs = (isWeb, tabActive) => {
    return isWeb || tabActive !== 'loyalty';
  };

  const renderSociollaTabs = () => {
    if (!shouldRenderTabs(isWeb, tabActive)) {
      return null;
    }

    return (
      <SociollaTabs
        testID="customer-detail-tabs"
        style={getSociollaTabsStyle(isWeb)}
        data={getSociollaTabsData(isWeb, getAvailableTabs(roleUser))}
        tabActive={tabActive}
        setTabActive={(val) => changeTab(val)}
      />
    );
  };

  const renderItemDetail = (name, type, required = false) => (
    <ItemDetail
      nameComponent={
        required ? (
          <View style={[styles.row, { display: 'flex' }]}>
            <SociollaText style={styles.label}>{name}</SociollaText>
            <SociollaText style={styles.required}>*</SociollaText>
          </View>
        ) : (
          <SociollaText style={styles.label}>{name}</SociollaText>
        )
      }
      // between={true}
      valueComponent={<ButtonUpload type={type} />}
      value="-"
    />
  );

  const renderDocumentSection = () => {
    const documentList = [];
    (customer?.is_active_for || []).map((c) => {
      if (legalDocuments[c]) {
        documentList.push(...legalDocuments[c]);
      }
    });

    return (
      <NoTranslate>
        <View style={styles.documentSection}>
          {documentList.map(({ label, key, required }) => (
            <View key={key}>{renderItemDetail(label, key, required)}</View>
          ))}
        </View>
      </NoTranslate>
    );
  };

  const renderSalesInfo = (customer) => (
    <>
      <ItemDetail name="Sales Team" value={customer.sales_team?.name || '-'} />
      <ItemDetail
        name="Market Type"
        value={
          customer.market_type?.code
            ? customer.market_type?.code.toUpperCase()
            : '-'
        }
      />
      <ItemDetail name="Business Type" value={businessType || '-'} />
      <ItemDetail
        name="Account"
        value={customer.market_type?.business_type?.account?.code || '-'}
      />
      <ItemDetail
        name="Regional Distributor Manager"
        value={
          customer.regional_distributor_manager?.length
            ? customer.regional_distributor_manager
                .map((el) => el.name)
                .join(', ')
            : '-'
        }
      />
      <ItemDetail
        name="Sales Admin"
        value={
          customer.sales_admin?.length
            ? customer.sales_admin.map((el) => el.name).join(', ')
            : '-'
        }
      />
      <ItemDetail
        name="Sales Person"
        value={customer.user?.sales_code || '-'}
      />
      {/* <ItemDetail name="Cover Area" value={customer.cover_area?.name || '-'} /> */}
    </>
  );

  const renderAdvisors = (customer) => (
    <>
      <ItemDetail
        name="Beauty Advisor"
        value={
          customer.beauty_advisor?.length
            ? customer.beauty_advisor.map((el) => el.name).join(', ')
            : '-'
        }
      />
      <ItemDetail
        name="Merchandiser"
        value={
          customer.merchandiser?.length
            ? customer.merchandiser.map((el) => el.name).join(', ')
            : '-'
        }
      />
      <ItemDetail
        name="Key Account Manager"
        value={
          customer.key_account_manager?.length
            ? customer.key_account_manager.map((el) => el.name).join(', ')
            : '-'
        }
      />
      <ItemDetail
        name="Account Manager"
        value={
          customer.account_manager?.length
            ? customer.account_manager.map((el) => el.name).join(', ')
            : '-'
        }
      />
    </>
  );

  const renderPaymentInfo = (customer) => (
    <>
      {renderItem(
        'Special Expired Date',
        customer.special_expired_period
          ? `${customer.special_expired_period.split('_')[0]} Months`
          : '-',
      )}
      {renderItem('Payment Terms', customer.payment_terms?.name)}
      <ItemDetail
        name="Limit Amount"
        nameComponent={
          <View>
            <SociollaText
              type={'regular'}
              style={{
                width: 130,
                fontSize: 12,
                color: Colors.grey1,
              }}>
              Limit Amount
            </SociollaText>
            <TouchableOpacity
              testID="customer-detail-credit-limit-info-btn"
              onPress={() => {
                creditLimitRef.current.measureInWindow(
                  (x, y, width, height) => {
                    setModalPosition({
                      top: y + height,
                      left: x,
                    });
                  },
                );
                setShowCreditLimitModal(true);
              }}
              ref={creditLimitRef}
              style={{
                width: 14,
                height: 14,
                marginLeft: 5,
                position: 'absolute',
                right: '10%',
              }}>
              <Image
                style={{
                  width: 14,
                  height: 14,
                }}
                width={14}
                height={14}
                source={require('@assets/img/icons/info-white.svg')}
                svg={true}
              />
            </TouchableOpacity>
          </View>
        }
        value={
          isKeyExists(customer, 'limit_amount')
            ? currency(customer.limit_amount)
            : '-'
        }
      />
      {renderItem(
        'Overdue Receivable',
        isKeyExists(customer, 'overdue_recievable')
          ? currency(customer.overdue_recievable)
          : '-',
      )}
      {renderItem(
        'Loyalty Point',
        isKeyExists(customer, 'loyalty_points')
          ? currency(customer.loyalty_points.count)
          : '-',
      )}
    </>
  );

  const renderBankDetails = (customer) => (
    <>
      {renderItem('Bank Name', customer?.bank_account?.name)}
      {renderItem('Branch', customer?.bank_account?.branch)}
      {renderItem('Account Number', customer?.bank_account?.account_number)}
      {renderItem('Account Name', customer?.bank_account?.owner_name)}
    </>
  );

  const renderCustomerStatus = (customer) => (
    <>
      {renderBankDetails(customer)}
      <ItemDetail
        name="Average Total Purchases"
        style={{
          flexDirection: 'column',
          justifyContent: isNative ? 'flex-start' : 'normal',
          alignItems: isNative ? 'flex-start' : 'normal',
        }}
        valueComponent={
          <View style={{ marginTop: 10 }}>
            <InputGroup
              testID="customer-detail-calculate-avg-btn"
              buttonLabel="Calculate"
              valueText={average.average || '0'}
              width={isWeb ? 300 : '100%'}
              styleInput={{
                backgroundColor: Colors.grey0,
              }}
              onPress={() => getCluster()}
            />
          </View>
        }
      />
      {renderItem(
        'Discount Regular',
        average.cluster || customer?.cluster?.name || '-',
      )}
      {renderItem('Customer Code', customer.customer_code)}
      {/* {renderItem("Status", customer.is_active ? "Active" : "Inactive")} */}
      {renderItem('Special Discount', `${customer.special_discount || 0}%`)}
      {renderItem(
        'Customer Type',
        customer.customer_type?._id
          ? customer.customer_type?.name
          : customer.customer_type
          ? CUSTOMER_TYPES_OBJ[customer.customer_type]
          : '-',
      )}
    </>
  );

  // const renderVisitDetails = (customer) => (
  //   <>
  //     <ItemDetail
  //       name="Visit Day"
  //       value={`${customer.visit_day ? VISIT_DAYS_OBJ[customer.visit_day] : '-'
  //         } ${customer.visit_week ? VISIT_WEEKS_OBJ[customer.visit_week] : ''}`}
  //     />
  //     <ItemDetail
  //       name="Visit Time"
  //       value={
  //         customer.visit_time
  //           ? `${customer.visit_time.from} - ${customer.visit_time.to}`
  //           : '-'
  //       }
  //     />
  //     <ItemDetail
  //       name="Visit Frequency"
  //       value={
  //         customer.visit_frequency
  //           ? customer.visit_frequency.toUpperCase()
  //           : '-'
  //       }
  //     />
  //   </>
  // );

  const renderSalesSection = () => (
    <View
      style={[
        styles.row,
        isWeb ? {} : { flexDirection: 'column' },
        { paddingVertical: 20, justifyContent: 'flex-start' },
      ]}>
      <View style={isWeb ? { flex: 1, marginRight: 20 } : {}}>
        {renderSalesInfo(customer)}
        {renderAdvisors(customer)}
        {renderPaymentInfo(customer)}
        {/* {renderBankDetails(customer)} */}
      </View>
      <View style={isWeb ? { flex: 1 } : {}}>
        {renderCustomerStatus(customer)}
        {/* {renderVisitDetails(customer)} */}
      </View>
    </View>
  );

  const renderAddressSection = () => (
    <View
      style={{
        paddingVertical: 20,
        justifyContent: 'flex-start',
      }}>
      {renderAddressCard()}
    </View>
  );

  const renderLoyaltyCard = (title, value, marginRight) => (
    <SociollaCard
      testID={`customer-detail-loyalty-${title
        .toLowerCase()
        .replace(/\s+/g, '-')}-card`}
      title={title}
      borderColor={false}
      titleStyle={{ fontSize: 12, color: Colors.black5 }}
      style={{
        minHeight: 78,
        maxWidth: isWeb ? 156 : 'auto',
        borderTopWidth: 0,
        backgroundColor: Colors.blue9,
        flex: 1,
        marginBottom: 0,
        marginRight: marginRight,
      }}>
      <SociollaText
        type="medium"
        style={{
          fontSize: 18,
          color: Colors.black3,
          position: 'absolute',
          bottom: 10,
          left: 16,
        }}
        currency={true}>
        {value}
      </SociollaText>
    </SociollaCard>
  );

  const renderEditLoyaltyButton = () =>
    isWeb &&
    hasAccessEditLoyalty &&
    customer.status === 'approved' && (
      <Button
        testID="customer-detail-edit-loyalty-btn"
        buttonStyle={{
          ...buttonRounded,
          backgroundColor: Colors.blue3,
          borderColor: Colors.blue3,
          paddingHorizontal: 10,
          alignSelf: 'center',
          justifyContent: 'center',
        }}
        title={
          <SociollaText
            type="bold"
            style={{
              fontSize: isWeb ? 14 : 15,
              lineHeight: 17,
              color: Colors.white,
              textAlign: 'center',
            }}>
            Edit Loyalty Point
          </SociollaText>
        }
        onPress={() => setModalLoyalty(true)}
      />
    );

  const renderLoyaltyLogHeader = () => (
    <SociollaText type="medium" style={styles.loyaltyLog}>
      LOYALTY POINT LOG
    </SociollaText>
  );

  const renderLoyaltyTable = () => (
    <SociollaTable
      testID="customer-detail-loyalty-table"
      ref={tableRef}
      table={[]}
      datas={loyaltyLogs}
      renderItem={logItem}
      scrollItem={true}
      withHeader={false}
      hideSearch={true}
      maxHeight={300}
      onEndReachedThreshold={0.3}
      emptyLabel={'No Log found.'}
      count={logs.count}
      loading={false}
      loadingLoadMore={loadingLoadMore}
      localParams={paramsLogs}
      styleContainer={{
        backgroundColor: Colors.white,
        shadowColor: Colors.white,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0,
        shadowRadius: 0,
        elevation: 0,
      }}
    />
  );

  const renderLoyaltySection = () => (
    <>
      <View
        style={[
          styles.row,
          { paddingVertical: 20, justifyContent: 'flex-start' },
          isWeb ? {} : { width: '100%' },
        ]}>
        {renderLoyaltyCard('Total Transaction', customer.total_orders || 0, 20)}
        {renderLoyaltyCard(
          'Total Loyalty Point',
          customer.loyalty_points?.count || 0,
          isWeb ? 40 : 0,
        )}
        {renderEditLoyaltyButton()}
      </View>
      {renderLoyaltyLogHeader()}
      {renderLoyaltyTable()}
    </>
  );

  const renderStatus = (status, setModalLog) => {
    return (
      <View>
        <ItemDetail
          name="Status"
          style={{ paddingHorizontal: 20, alignItems: 'center', width: '100%' }}
          valueComponent={
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}>
              <View
                testID="customer-detail-status-badge"
                style={{
                  fontSize: 12,
                  color: Colors.black1,
                  backgroundColor: status.color,
                  textAlign: 'center',
                  width: !isWeb ? 150 : 200,
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  paddingVertical: 7,
                  borderRadius: 4,
                  paddingHorizontal: 12,
                }}>
                <NoTranslate>
                  <SociollaText>{status.label}</SociollaText>
                </NoTranslate>
              </View>
              <TouchableOpacity
                testID="customer-detail-see-log-btn"
                onPress={() => setModalLog(true)}>
                <SociollaText
                  style={{
                    fontSize: 12,
                    color: Colors.blue0,
                    marginLeft: 20,
                    zIndex: 99,
                  }}>
                  see log
                </SociollaText>
              </TouchableOpacity>
            </View>
          }
        />
      </View>
    );
  };

  const renderIsActive = () => {
    return (
      <View>
        <ItemDetail
          name="Is Active"
          style={{ paddingHorizontal: 20, alignItems: 'center', width: '100%' }}
          valueComponent={
            <View
              testID="customer-detail-is-active-badge"
              style={{
                fontSize: 12,
                color: Colors.black1,
                backgroundColor: customer.is_active ? '#E2F7E4' : '#FCDCE3',
                textAlign: 'center',
                width: !isWeb ? 150 : 200,
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                paddingVertical: 7,
                borderRadius: 4,
                paddingHorizontal: 12,
              }}>
              <NoTranslate>
                <SociollaText>
                  {customer.is_active ? 'Active' : 'Not active'}
                </SociollaText>
              </NoTranslate>
            </View>
          }
        />
      </View>
    );
  };

  const getApprovals = (customer, customerCluster) => {
    if (customer?.status === 'need_approval') {
      const curApproval = customer?.current_approval || '';
      return (customer?.list_approval || []).filter(
        (a) => a.role == curApproval,
      );
    }
    return [];
  };

  const renderApprovalList = (approvals, showAll) => {
    const displayedApprovals = showAll ? approvals : approvals.slice(0, 3);

    return displayedApprovals.map((appr, index) => (
      <User
        name={appr.name || ''}
        image={appr.image || ''}
        key={`list-user-approval-${index}`}
        index={index}
        style={{ paddingBottom: isWeb ? 10 : 5, marginBottom: isWeb ? 0 : 20 }}
      />
    ));
  };

  const renderSeeAllButton = (approvals, showAll, setShowAll) => {
    if (approvals.length <= 3) {
      return null;
    }

    return (
      <TouchableOpacity
        testID="customer-detail-see-all-approvals-btn"
        onPress={() => setShowAll(!showAll)}>
        <SociollaText
          style={{ fontSize: 12, color: Colors.blue0, marginTop: 5 }}>
          {showAll ? 'See Less' : 'See All'}
        </SociollaText>
      </TouchableOpacity>
    );
  };

  const renderWaitingApproval = (customer, customerCluster) => {
    const approvals = getApprovals(customer, customerCluster);

    return (
      <ItemDetail
        name="Waiting Approval"
        style={{
          paddingHorizontal: 20,
          alignItems: 'flex-start',
          marginBottom: isWeb ? 0 : -25,
        }}
        withoutBorder={true}
        valueComponent={
          <View style={{ flexDirection: 'column' }}>
            {renderApprovalList(approvals, showAll)}
            {renderSeeAllButton(approvals, showAll, setShowAll)}
          </View>
        }
      />
    );
  };

  const renderRejectedInfo = (lastStatus) => {
    return (
      <>
        <ItemDetail
          name="Rejected By"
          style={{ paddingHorizontal: 20, alignItems: 'flex-start' }}
          valueComponent={
            <User name={lastStatus?.name} image={lastStatus?.img} index={0} />
          }
        />
        <ItemDetail
          name="Notes"
          style={{ paddingHorizontal: 20, alignItems: 'flex-start' }}
          withoutBorder={true}
          valueComponent={
            <SociollaText style={{ fontSize: 12, color: Colors.black1 }}>
              {lastStatus?.reason || ''}
            </SociollaText>
          }
        />
      </>
    );
  };

  const renderCompanyInfo = (customer, isWeb) => {
    return (
      <View
        style={[
          { paddingVertical: 20, justifyContent: 'flex-start' },
          isWeb ? styles.row : { flexDirection: 'column' },
        ]}>
        <View style={isWeb ? { width: '50%', paddingRight: 20 } : {}}>
          {renderCompanyDetails(customer)}
        </View>
        <View style={isWeb ? { width: '50%', paddingLeft: 20 } : {}}>
          {renderAdditionalCompanyDetails(customer)}
        </View>
      </View>
    );
  };

  const renderSignatures = () => {
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: isWeb ? 'row' : 'column',
          gap: 10,
          marginTop: 20,
          paddingBottom: 80,
        }}>
        <ESignature
          testID="customer-detail-esign-prepared-by"
          hasEdit={hasAccessEditSignatures}
          onlyDraw={true}
          name={signatures.prepared_by?.name}
          showName={true}
          label="Prepared by"
          esignImage={signatures.prepared_by?.url}
          dateSigned={signatures.prepared_by?.created_at}
          onChange={async (v) => {
            await setSignatures({
              ...signatures,
              prepared_by: {
                ...signatures.prepared_by,
                url: v,
                name: signatures.prepared_by?.name,
              },
            });
            await updateSignaturesCustomer({
              type: 'prepared_by',
              url: v,
              name: signatures.prepared_by?.name,
            });
          }}
          onChangeName={(v) => {
            setSignatures({
              ...signatures,
              prepared_by: {
                ...signatures.prepared_by,
                name: v,
              },
            });
          }}
          isRequired={false}
        />
        <ESignature
          testID="customer-detail-esign-acknowledged-by"
          hasEdit={hasAccessEditSignatures}
          onlyDraw={true}
          label="Acknowledged by"
          showName={true}
          name={signatures.acknowledge_by?.name}
          esignImage={signatures.acknowledge_by?.url}
          dateSigned={signatures.acknowledge_by?.created_at}
          onChange={async (v) => {
            await setSignatures({
              ...signatures,
              acknowledge_by: {
                ...signatures.acknowledge_by,
                url: v,
                name: signatures.acknowledge_by?.name,
              },
            });
            await updateSignaturesCustomer({
              type: 'acknowledge_by',
              url: v,
              name: signatures.acknowledge_by?.name,
            });
          }}
          onChangeName={(v) => {
            setSignatures({
              ...signatures,
              acknowledge_by: {
                ...signatures.acknowledge_by,
                name: v,
              },
            });
          }}
          isRequired={false}
        />
        <ESignature
          testID="customer-detail-esign-customer"
          hasEdit={hasAccessEditSignatures}
          onlyDraw={true}
          showTick={true}
          showName={true}
          name={signatures.customer_by?.name}
          label="Customer"
          esignImage={signatures.customer_by?.url}
          dateSigned={signatures.customer_by?.created_at}
          onChange={async (v) => {
            await setSignatures({
              ...signatures,
              customer_by: {
                ...signatures.customer_by,
                url: v,
                name: signatures.customer_by?.name,
                is_ticked: signatures.customer_by?.is_ticked,
              },
            });
            await updateSignaturesCustomer({
              type: 'customer_by',
              url: v,
              name: signatures.customer_by?.name,
              is_ticked: true,
            });
          }}
          onChangeName={(v) => {
            setSignatures({
              ...signatures,
              customer_by: {
                ...signatures.customer_by,
                name: v,
              },
            });
          }}
          onChangeDone={(v) => {
            setSignatures({
              ...signatures,
              customer_by: {
                ...signatures.customer_by,
                is_ticked: v,
              },
            });
          }}
          isRequired={false}
        />
      </View>
    );
  };

  const renderLocation = () => {
    return customer?.delivery_address?.length > 0 &&
      customer.delivery_address[0].lat_long?.latitude &&
      customer.delivery_address[0].lat_long?.longitude ? (
      <ItemDetail
        name="Location"
        style={{ flexDirection: 'column' }}
        valueComponent={
          <MapPicker
            value={customer.delivery_address[0].lat_long}
            hideInput={true}
            disabled={true}
            editable={false}
            containerStyle={{
              marginTop: 14,
              borderRadius: 4,
              width: '100%',
            }}
          />
        }
      />
    ) : (
      <ItemDetail
        name="Location"
        valueComponent={
          <View style={{ flexDirection: 'column' }}>
            <View
              style={{
                flexDirection: 'row',
                marginBottom: 6,
              }}>
              <Image
                style={{ width: 14, height: 14 }}
                width={14}
                height={14}
                svg={true}
                source={require('@assets/img/icons/attention-red.svg')}
              />
              <SociollaText
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  color: Colors.red3,
                }}>
                Address pinpoint not set
              </SociollaText>
            </View>
            <SociollaText
              style={{
                marginLeft: 24,
                fontSize: 10,
                color: Colors.black3,
              }}>
              Edit address to add pinpoint location
            </SociollaText>
          </View>
        }
      />
    );
  };

  const renderItem = (name, value) => (
    <ItemDetail name={name} value={value || '-'} />
  );

  const renderCompanyDetails = (customer) => (
    <>
      {renderItem('Country ID', customer.country?.name)}
      {renderItem(isVn() ? 'City ID' : 'State ID', customer.state?.name)}
      {renderItem(isVn() ? 'District Area' : 'City', customer.city?.name)}
      {!isVn() && renderItem('District', customer.district?.name)}
      {renderItem('ZIP Code', customer.postal_code)}
      {renderItem('Street', customer.street)}
      {renderItem('Street 2', customer.street2)}
      {renderLocation()}
    </>
  );

  const renderAdditionalCompanyDetails = (customer) => (
    <>
      {renderItem('Taxable Entrepreneur', PKP_TYPES_OBJ[customer.is_pkp])}
      {renderItem(
        'WHT (Corporate/Personal)',
        WHT.find((el) => el.value == customer.wht)?.label,
      )}
      {renderItem('Phone', customer.phone)}
      {renderItem('Mobile', customer.mobile)}
      {renderItem('Email', customer.email)}
      {renderItem('Person in Charge (PIC)', customer.owner_name)}
      {renderItem('Job Title', customer.job_position)}
      {renderItem('Payment Type', PAYMENT_TYPES_OBJ[customer.payment_type])}
      {renderItem('Notes', customer.notes)}
      <ItemDetail
        name="Sub Distributor"
        valueComponent={
          <CheckBox
            testID="customer-detail-subdis-checkbox"
            checked={customer.is_sub_distributor ? true : false}
            onChange={handleChangeSubdis}
            disabled={!hasAccessSubdis}
          />
        }
      />
    </>
  );

  const renderCustomerDetails = () => {
    if (tabActive !== 'details') {
      return null;
    }
    return (
      <>
        <SociollaText
          type="medium"
          style={{
            fontSize: 12,
            color: Colors.black5,
            paddingVertical: 18,
            paddingLeft: 20,
            backgroundColor: Colors.grey3,
            letterSpacing: 1,
            marginHorizontal: -20,
          }}>
          COMPANY INFO
        </SociollaText>
        {renderCompanyInfo(customer, isWeb)}
        {!isVn() && (
          <>
            <SociollaText
              type="medium"
              style={{
                fontSize: 12,
                color: Colors.black5,
                paddingVertical: 18,
                paddingLeft: 20,
                backgroundColor: Colors.grey3,
                letterSpacing: 1,
                marginHorizontal: -20,
              }}>
              E - SIGNATURE
            </SociollaText>
            {renderSignatures()}
          </>
        )}
      </>
    );
  };

  const renderContent = () => {
    switch (tabActive) {
      case 'details':
        return renderCustomerDetails();
      case 'loyalty':
        return renderLoyaltySection();
      case 'address':
        return !loading ? renderAddressSection() : null;
      case 'sales':
        return renderSalesSection();
      case 'document':
        return renderDocumentSection();
      default:
        return null;
    }
  };

  const getContentContainerStyle = () => ({
    paddingBottom: canApprove && !isWeb ? 40 : 0,
  });

  const renderTabContent = () => renderContent();

  const SalesInfoCard = ({ title, countData, customer, screen }) => {
    if (countData.loading) {
      return null;
    }

    return (
      <SociollaCard
        testID={`customer-detail-mobile-${title.toLowerCase()}-card`}
        title={title}
        borderColor={false}
        titleStyle={{ fontSize: 12, color: Colors.black5 }}
        onPress={() =>
          props.navigation.navigate('SalesOrderNavigator', {
            screen,
            params: { customerId: customer?._id, titleScreen: customer?.name },
          })
        }
        style={{
          minHeight: 78,
          borderTopWidth: 0,
          backgroundColor: Colors.blue9,
          flex: title === 'Sales' ? 1 : 2,
          marginRight: title === 'Sales' ? 16 : 0,
        }}>
        <SociollaText
          type="medium"
          style={{
            fontSize: 18,
            color: Colors.black3,
            position: 'absolute',
            bottom: 16,
            right: 16,
          }}
          currency={title === 'Invoice' ? true : false}>
          {countData.error ? 0 : countData.data}
        </SociollaText>
      </SociollaCard>
    );
  };

  const renderSalesCard = (salesCount, customer) => (
    <SalesInfoCard
      title="Sales"
      countData={salesCount}
      customer={customer}
      screen="SalesOrderScreen"
    />
  );

  const renderInvoiceCard = (totalInvoice, customer) => (
    <SalesInfoCard
      title="Invoice"
      countData={totalInvoice}
      customer={customer}
      screen="SalesOrderInvoiceScreen"
    />
  );

  const renderSalesAndInvoice = () => {
    if (!isWeb && ['document', 'loyalty'].indexOf(tabActive) === -1) {
      return (
        <View
          style={[styles.row, { marginTop: isWeb ? 20 : 5, width: '100%' }]}>
          {renderSalesCard(salesCount, customer)}
          {renderInvoiceCard(totalInvoice, customer)}
        </View>
      );
    }
  };

  const renderCustomerImageContent = useMemo(
    () => (customer) =>
      (
        <View
          style={{
            width: isWeb ? 130 : 90,
            height: isWeb ? 130 : 90,
            borderRadius: 8,
            overflow: 'hidden',
          }}>
          <Image
            testID="customer-detail-image"
            style={{
              height: '100%',
              borderRadius: 8,
              resizeMode: 'contain',
            }}
            width={isWeb ? 130 : 90}
            height={isWeb ? 130 : 90}
            isPhoto={true}
            isManualReload={isAndroid ? true : false}
            source={getCustomerImageSource(customer)}
          />
          {renderImageOverlay(customer)}
        </View>
      ),
    [customer],
  );

  const renderCustomerImage = useCallback(
    (customer, dispatch) => (
      <TouchableOpacity
        testID="customer-detail-image-btn"
        style={{
          width: isWeb ? 70 : 30,
          height: isWeb ? 70 : 30,
          marginRight: 20,
        }}
        onPress={() => {
          if (customer.image) {
            dispatch(
              showImage({
                isModal: true,
                isMultiple:
                  Array.isArray(customer?.image) && customer?.image.length > 0,
                allImage: customer?.image.length > 0 ? customer?.image : [],
                url:
                  Array.isArray(customer?.image) && customer.image?.length
                    ? customer.image[0]
                    : customer?.image !== ''
                    ? customer.image
                    : img,
              }),
            );
          }
        }}>
        {renderCustomerImageContent(customer)}
      </TouchableOpacity>
    ),
    [showImage],
  );

  const getCustomerImageSource = (customer) => {
    if (Array.isArray(customer?.image) && customer.image?.length) {
      return customer.image[0];
    }
    if (!Array.isArray(customer?.image) && customer?.image !== '') {
      return customer.image;
    }
    return img;
  };

  const renderImageOverlay = (customer) => (
    <View
      testID="customer-detail-image-overlay"
      style={{
        position: 'absolute',
        bottom: 4,
        right: 4,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
      }}>
      {renderImageCounter(customer)}
    </View>
  );

  const renderImageCounter = (customer) => (
    <View
      testID="customer-detail-image-counter"
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Text
        testID="customer-detail-image-counter-text"
        style={{ color: '#fff', fontSize: 9, marginRight: 4 }}>
        {Array.isArray(customer?.image) && customer.image.length > 0
          ? `1 / ${customer?.image?.length}`
          : customer?.image !== ''
          ? '1/1'
          : '0/0'}
      </Text>
      <Image
        style={{ width: 9, height: 9 }}
        width={9}
        height={9}
        svg
        source={require('@assets/img/icons/gallery.svg')}
      />
    </View>
  );

  const renderCustomerName = (customer) => {
    const maxLength = isWeb ? 70 : 32;

    return (
      <>
        <SociollaText
          testID="customer-detail-name"
          type="medium"
          style={{
            fontSize: isWeb ? 18 : 16,
            color: Colors.black3,
            marginTop: 10,
            maxWidth: isWeb ? '73%' : 300,
          }}
          numberOfLines={4}>
          <View style={{ top: isWeb ? -2 : 0 }}>
            {customer.customer_type === 'b2b_vip' && <VipBadge />}
          </View>
          {customer.name?.length > maxLength
            ? `${customer.name.substring(0, maxLength)}...`
            : customer.name || '-'}
        </SociollaText>
      </>
    );
  };

  const renderStatusButton = (customer, alertStatus) => (
    <Button
      testID="customer-detail-status-btn"
      type="primary"
      rounded={true}
      buttonStyle={{ width: 100 }}
      title={customer.is_active ? 'In Active' : 'Active'}
      onPress={() => alertStatus(customer.is_active)}
    />
  );

  const renderEditButton = (customer) => (
    <Button
      testID="customer-detail-edit-btn"
      type="primary"
      rounded={true}
      buttonStyle={{ width: 80 }}
      title={
        <View style={{ flexDirection: 'row' }}>
          <Image
            width={14}
            height={14}
            style={{ width: 14, height: 14, marginRight: 12 }}
            svg={true}
            source={require('@assets/img/icons/edit-white.svg')}
          />
          <SociollaText
            type="bold"
            style={{ fontSize: 14, lineHeight: 17, color: Colors.white }}>
            Edit
          </SociollaText>
        </View>
      }
      onPress={() => {
        props.navigation.navigate('CustomerRegisterNavigator', {
          screen: 'CustomerRegistrationScreen',
          params: { id: customer._id },
        });
      }}
    />
  );

  const renderExportButton = (customer) => (
    <Button
      testID="customer-detail-export-pdf-btn"
      type="primary"
      rounded={true}
      buttonStyle={{ width: 42 }}
      title={
        <Image
          style={{
            width: 13,
            height: 17,
          }}
          width={13}
          height={17}
          source={require('@assets/img/icons/pdf.png')}
        />
      }
      onPress={() => {
        if (customer?._id) {
          onExportPdf(customer?._id);
        }
      }}
    />
  );

  const renderSeparatorBottom = () => (
    <View
      style={{
        borderBottomWidth: 1,
        borderBottomColor: Colors.grey0,
        width: '100%',
        marginTop: 20,
      }}
    />
  );

  const renderCustomerInfoWeb = (customer, dispatch) => {
    return (
      <View style={[styles.row, customerNameStyle, { display: 'flex' }]}>
        {renderCustomerImage(customer, dispatch)}
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            marginLeft: 70,
          }}>
          {renderCustomerName(customer)}
          {renderSeparatorBottom()}
          {status && (
            <>
              {renderStatus(status, setModalLog)}
              {renderIsActive()}
              {status.value === 'need_approval' &&
                renderWaitingApproval(customer, customerCluster)}
              {status.value === 'rejected' && renderRejectedInfo(lastStatus)}
            </>
          )}
          {/* {status?.value === 'need_approval' && renderSeparatorBottom()} */}
        </View>
      </View>
    );
  };

  const renderCustomerInfoMobile = (customer, dispatch) => {
    return (
      <View style={{ display: 'flex', flexDirection: 'col' }}>
        <View
          style={[
            styles.row,
            customerNameStyle,
            { display: 'flex', padding: 20 },
          ]}>
          {renderCustomerImage(customer, dispatch)}
          <View
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              marginLeft: 70,
              maxWidth: 220,
              marginTop: -5,
            }}>
            {renderCustomerName(customer)}
          </View>
        </View>
        <View style={{ marginTop: 34, width: fullWidth }}>
          {renderSeparatorBottom()}
          {status && (
            <>
              {renderStatus(status, setModalLog)}
              {renderIsActive()}
              {status.value === 'need_approval' &&
                renderWaitingApproval(customer, customerCluster)}
              {status.value === 'rejected' && renderRejectedInfo(lastStatus)}
            </>
          )}
          {status?.value === 'need_approval' && renderSeparatorBottom()}
        </View>
      </View>
    );
  };

  const renderWebElements = (customer, alertStatus, tabActive, showEdit) => (
    <>
      {hasAccessStatus && renderStatusButton(customer, alertStatus)}
      {tabActive !== 'loyalty' &&
        !isVn() &&
        hasAccessExportPDF &&
        renderExportButton(customer)}
      {tabActive !== 'loyalty' && showEdit && renderEditButton(customer)}
    </>
  );

  const renderCustomerHeader = useMemo(
    () => (
      <View style={[styles.row, isWeb ? styles.leftContainerHeader : {}]}>
        {isWeb && renderCustomerInfoWeb(customer, dispatch)}
        {!isWeb && renderCustomerInfoMobile(customer, dispatch)}
        {isWeb && renderWebElements(customer, alertStatus, tabActive, showEdit)}
      </View>
    ),
    [customer, showAll],
  );

  const renderCustomerDetailView = () => (
    <ScrollContainer contentContainerStyle={getContentContainerStyle()}>
      <View
        style={[
          styles.containerDetail,
          isWeb && tabActive === 'loyalty' ? { paddingBottom: 0 } : {},
        ]}>
        {renderCustomerHeader}
        <View style={{ padding: isWeb ? 0 : 20 }}>
          {renderSalesAndInvoice()}
          {roleUser && renderSociollaTabs()}
          {renderTabContent()}
        </View>
      </View>
    </ScrollContainer>
  );

  const renderCustomerData = () => (
    <View style={styles.leftContainer}>
      {customerTitle()}
      {renderCustomerDetailView()}
    </View>
  );

  const renderDetailContent = () => {
    return loading ? (
      <Layout.Loader />
    ) : (
      <View style={styles.container}>
        {renderCustomerData()}
        {renderRightHeader()}
        {approveButtons()}
      </View>
    );
  };

  return (
    <Layout.Container testID="customer-detail-screen">
      {backButtonWeb()}
      {renderDetailContent()}
      {renderAllModal()}
      {customer._id ? (
        <>
          {isWeb ? (
            <FloatCommentButton
              onPress={() => setShowComments(true)}
              drawerVisible={showComments}
              entityType="customer"
              entityId={customer._id}
            />
          ) : (
            false
          )}
          <CommentDrawer
            visible={showComments}
            onClose={() => setShowComments(false)}
            entityType="customer"
            entityId={customer._id}
            entityRef={customer.name}
          />
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: isWeb ? 'row' : 'column',
    width: '100%',
    flex: isWeb ? 'none' : 1,
  },
  containerDetail: {
    backgroundColor: Colors.white,
    borderRadius: 4,
    padding: isWeb ? 20 : 0,
    flex: 1,
  },
  leftContainer: {
    //width: isWeb ? '75%' : '100%',
    flex: isWeb ? 3 : 1,
  },
  leftContainerHeader: {
    justifyContent: 'space-between',
  },
  headerRightRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightContainer: {
    flex: 1,
    //width: isWeb ? '25%' : '100%',
    paddingLeft: isWeb ? 30 : 0,
  },
  row: {
    flexDirection: 'row',
    width: '100%',
  },
  label: {
    fontSize: 12,
    color: Colors.grey1,
  },
  required: {
    fontSize: 16,
    color: Colors.blue0,
    paddingLeft: 2,
    marginTop: -2,
  },
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginHorizontal: 10,
  },
  containerAddress: {
    marginBottom: isWeb ? 15 : 8,
  },
  headerGridContainer: {
    marginTop: 15,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
  },
  headerGridText: {
    fontSize: 14,
    color: Colors.black3,
    textAlign: 'left',
  },
  gridItem: {
    borderRadius: 6,
    padding: 20,
    marginBottom: 20,
    alignItems: 'center',
    height: 126,
  },
  addAddressButton: {
    borderRadius: 1,
    padding: 10,
    marginTop: 25,
  },
  addAddressText: {
    color: Colors.grey14,
    fontWeight: '600',
    textAlign: 'center',
    letterSpacing: 1,
    fontSize: 15,
  },
  loyaltyLog: {
    fontSize: 12,
    color: Colors.black5,
    paddingVertical: 18,
    paddingLeft: 20,
    backgroundColor: Colors.grey3,
    letterSpacing: 1,
    marginHorizontal: -20,
  },
  documentSection: { paddingVertical: 20, justifyContent: 'flex-start' },
  documentItemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    flexWrap: 'wrap',
  },
  documentItemList: {
    width: isWeb ? 180 : 140,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: Colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default CustomerDetail;
